import React, { useEffect } from 'react'
import { Tabs } from 'antd'
import { Building2, Link2, Receipt, Truck, Users, UserCog, FolderOpen } from 'lucide-react'
import { CompanySettings } from './CompanySettings'
import { PurchaseOrderSettings } from './PurchaseOrderSettings'
import { ProjectSettings } from './ProjectSettings'
import { IntegrationsOverview } from './Integrations/Overview'
import { UserList } from './UserManagement/UserList'
import { useLocation, useNavigate } from 'react-router-dom'
import { BillingPage } from './BillingPage'
import { useCompanyStore } from '../../store/company/companyStore'

type TabItem = {
  key: string
  label: React.ReactNode
  children: React.ReactNode | null
}

export const SettingsTabs: React.FC = () => {
  // get current route
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const user = useCompanyStore((state) => state.user)

  const [activeTab, setActiveTab] = React.useState('company')

  const tabs: TabItem[] = [
    {
      key: 'company',
      label: (
        <span className="flex items-center gap-2">
          <Building2 className="h-4 w-4" />
          Company
        </span>
      ),
      children: <CompanySettings />
    },
    {
      key: 'projects',
      label: (
        <span className="flex items-center gap-2">
          <FolderOpen className="h-4 w-4" />
          Projects
        </span>
      ),
      children: <ProjectSettings />
    },
    {
      key: 'purchase-orders',
      label: (
        <span className="flex items-center gap-2">
          <Truck className="h-4 w-4" />
          Purchase Orders
        </span>
      ),
      children: <PurchaseOrderSettings />
    },
    {
      key: 'integrations',
      label: (
        <span className="flex items-center gap-2">
          <Link2 className="h-4 w-4" />
          Integrations
        </span>
      ),
      children: <IntegrationsOverview />
    },
    {
      key: 'users',
      label: (
        <span className="flex items-center gap-2">
          <Users className="h-4 w-4" />
          Team Members
        </span>
      ),
      children: <UserList />
    },
    {
      key: 'billing',
      label: (
        <span className="flex items-center gap-2">
          <Receipt className="h-4 w-4" />
          Billing
        </span>
      ),
      children: <BillingPage />
    }
    // {
    //   key: 'account',
    //   label: (
    //     <span className="flex items-center gap-2">
    //       <User className="h-4 w-4" />
    //       Account
    //     </span>
    //   ),
    //   children: <AccountSettings />,
    // },
    // {
    //   key: 'notifications',
    //   label: (
    //     <span className="flex items-center gap-2">
    //       <Bell className="h-4 w-4" />
    //       Notifications
    //     </span>
    //   ),
    //   children: <NotificationSettings />,
    // },
  ]

const onChangeTab = (key: string) => {
  if (key === 'login-as') {
    navigate('/app/settings/login-as')
  } else {
    navigate(`/app/settings/${key}`)
  }
}

useEffect(() => {
  const tab = tabs.find((tab) => pathname.includes(tab.key))
  if (tab) {
    setActiveTab(tab.key)
  }
}, [pathname])

return <Tabs activeKey={activeTab} items={tabs} onChange={onChangeTab} />
}
